import { ChakraFlex, Text, Counter, FireflyButton } from '@equip.health/ui';

type Props = {
  id: string;
  title: string;
  count: number;
  expandAllLabel: string;
  onExpandAllClick: () => void;
};

export const CarePlanSectionHeader = ({
  id,
  title,
  count,
  expandAllLabel,
  onExpandAllClick,
}: Props) => {
  return (
    <ChakraFlex
      justifyContent="space-between"
      alignItems="center"
      marginBottom="16px"
    >
      <ChakraFlex alignItems="center">
        <Text marginRight="6px" variant="h5">
          {title}
        </Text>
        {count > 0 && <Counter id={`${id}__counter`} number={count} />}
      </ChakraFlex>
      <FireflyButton
        id={`${id}-expand-all-button`}
        onClick={onExpandAllClick}
        variant="tertiary"
      >
        {expandAllLabel}
      </FireflyButton>
    </ChakraFlex>
  );
};
